import {Component, OnInit} from '@angular/core';
import {GetSetDataService} from '../../services/get-set-data.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  public loaderVisible: boolean = true;

  constructor(private getSetData: GetSetDataService) {
  }

  ngOnInit() {
    this.getSetData.EmitterLoader.subscribe((data: boolean) => {
      this.loaderVisible = data;
    });
  }
}
